export const localTeamData = [
  {
    id: 198,
    date: '2025-01-24T18:18:33',
    date_gmt: '2025-01-24T18:18:33',
    guid: {
      rendered: 'https://cms.modlingroup.dbox.com/?post_type=modlin_group_team&#038;p=198'
    },
    modified: '2025-01-24T20:01:19',
    modified_gmt: '2025-01-24T20:01:19',
    slug: 'gabriella-davidson',
    status: 'publish',
    type: 'modlin_group_team',
    link: 'https://cms.modlingroup.dbox.com/modlin_group_team/gabriella-davidson/',
    title: {
      rendered: 'Gabriella Davidson'
    },
    content: {
      rendered: '',
      protected: false
    },
    featured_media: 0,
    template: '',
    acf: {
      name: 'Gabriella Davidson',
      position: 'Licensed Real Estate Salesperson',
      phone: '',
      cell: '9175800591',
      email: 'Gabriella@modlingroup.com',
      bio: '<p>Gabriella was born and raised in New York City. Growing up on the Upper East Side, she developed an appreciation for the luxury buildings that define the neighborhood. Gabriella pursued her academic interests at New York University, majoring in History.</p>\n<p>A true New Yorker, Gabriella loves to explore every corner of the city. Known for her keen listening skills, she builds deep and lasting relationships with those around her. Gabriella possesses a detail-oriented mindset and has sophisticated, discerning taste.\u00a0Her passion for real estate drives her to stay informed about the<a class="css-1rn59kg" title="https://www.google.com/maps/search/152+West%0D%0A+57th+Street+%0D%0A+New+York,%0D%0A+NY++10019?entry=gmail&amp;source=g" href="https://www.google.com/maps/search/152+West%0D%0A+57th+Street+%0D%0A+New+York,%0D%0A+NY++10019?entry=gmail&amp;source=g">\u00a0</a>latest market trends and opportunities in the city. In her free time, she enjoys traveling,\u00a0skiing, and playing tennis. She currently resides in the Flatiron District.</p>\n',
      headshot: '/team/Gabriella_Davidson.png',
      executive: false,
      location: 'MANHATTAN'
    },
    _links: {
      self: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/modlin_group_team/198'
        }
      ],
      collection: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/modlin_group_team'
        }
      ],
      about: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/types/modlin_group_team'
        }
      ],
      'wp:attachment': [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/media?parent=198'
        }
      ],
      curies: [
        {
          name: 'wp',
          href: 'https://api.w.org/{rel}',
          templated: true
        }
      ]
    }
  },
  {
    id: 34,
    date: '2020-06-05T17:40:21',
    date_gmt: '2020-06-05T17:40:21',
    guid: {
      rendered: 'http://3.228.218.122/?post_type=modlin_group_team&#038;p=34'
    },
    modified: '2023-02-20T11:31:40',
    modified_gmt: '2023-02-20T11:31:40',
    slug: 'adam-modlin',
    status: 'publish',
    type: 'modlin_group_team',
    link: 'https://cms.modlingroup.dbox.com/modlin_group_team/adam-modlin/',
    title: {
      rendered: 'Adam Modlin'
    },
    content: {
      rendered: '',
      protected: false
    },
    featured_media: 0,
    template: '',
    acf: {
      name: 'Adam D. Modlin',
      position: 'Founder and Chief Executive Officer',
      phone: '2125863821',
      phone_extension: '',
      cell: '',
      email: 'adam@modlingroup.com',
      bio: '<p>Modlin Group is a boutique real estate agency in New York City. Founded by Adam D. Modlin in 1999, the company has a 20-year plus track record for closing high profile complex transactions. The company has built its business solely on developing personal relationships with clients which span around the globe. Modlin Group has a reputation for its commitment to excellence, character, integrity and respect. The company has a niche for representing Townhouses, Penthouses and large residences. Modlin Group operates more like a family office than a traditional brokerage company. With a personal touch, Modlin Group plays the role as advisor and partner guiding clients with discretion, trust, privacy, professionalism and passion as its core values.</p>\n<p>While Modlin Group\u2019s expertise is in New York, the company has developed alliances and advises clients in the Hamptons, Boston, Miami, Los Angeles, Aspen, London, Tel Aviv and beyond.</p>\n<p>Recently, Modlin Group represented the sale of the most expensive single-family townhouse in the history of New York, 14-16 East 67 th Street for $77 million.</p>\n',
      headshot: '/team/Modlin_Group_Adam_500.jpg',
      executive: true,
      location: 'MANHATTAN'
    },
    _links: {
      self: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/modlin_group_team/34'
        }
      ],
      collection: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/modlin_group_team'
        }
      ],
      about: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/types/modlin_group_team'
        }
      ],
      'wp:attachment': [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/media?parent=34'
        }
      ],
      curies: [
        {
          name: 'wp',
          href: 'https://api.w.org/{rel}',
          templated: true
        }
      ]
    }
  },
  {
    id: 53,
    date: '2020-06-05T18:23:40',
    date_gmt: '2020-06-05T18:23:40',
    guid: {
      rendered: 'http://3.228.218.122/?post_type=modlin_group_team&#038;p=53'
    },
    modified: '2020-07-02T16:24:48',
    modified_gmt: '2020-07-02T16:24:48',
    slug: 'eduardo-cabrera',
    status: 'publish',
    type: 'modlin_group_team',
    link: 'https://cms.modlingroup.dbox.com/modlin_group_team/eduardo-cabrera/',
    title: {
      rendered: 'Eduardo Cabrera'
    },
    content: {
      rendered: '',
      protected: false
    },
    featured_media: 0,
    template: '',
    acf: {
      name: 'Eduardo Cabrera',
      position: 'Licensed Real Estate Salesperson',
      phone: '2129740740',
      phone_extension: '10',
      cell: '9414476335',
      email: 'eduardo@modlingroup.com',
      bio: '<p>Eduardo Cabrera is a licensed real estate broker in New York City. Bilingual with extensive international experience, he is passionate about real estate and \u200bstrives to provide high-quality, personalized service to each and every one of his clients. Thanks to his committed work ethic and engaging personality, Eduardo builds trust and maintains strong relationships. As a valued member of the Modlin Group team, Eduardo represents the firm\u2019s commitment to professionalism, discretion and above all, trust.</p>\n<p>Originally from Bogot\u00e1, Colombia, Eduardo came to the United States to pursue tennis at the highest level. Eduardo was recruited by the world-renowned tennis division of the International Management Group (IMG) in Florida. Through rigorous training and professional competition, Eduardo earned a tennis scholarship at Dalton State University, where he received a BA in International Business. Balancing these demands shaped Eduardo into the disciplined and driven professional he is today.</p>\n',
      headshot: '/team/Modlin_Group_Eduardo_500.jpg',
      executive: false
    },
    _links: {
      self: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/modlin_group_team/53'
        }
      ],
      collection: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/modlin_group_team'
        }
      ],
      about: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/types/modlin_group_team'
        }
      ],
      'wp:attachment': [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/media?parent=53'
        }
      ],
      curies: [
        {
          name: 'wp',
          href: 'https://api.w.org/{rel}',
          templated: true
        }
      ]
    }
  },
  {
    id: 146,
    date: '2023-02-10T17:59:54',
    date_gmt: '2023-02-10T17:59:54',
    guid: {
      rendered: 'https://cms.modlingroup.dbox.com/?post_type=modlin_group_team&#038;p=146'
    },
    modified: '2023-09-13T14:51:03',
    modified_gmt: '2023-09-13T14:51:03',
    slug: 'chris-covert',
    status: 'publish',
    type: 'modlin_group_team',
    link: 'https://cms.modlingroup.dbox.com/modlin_group_team/chris-covert/',
    title: {
      rendered: 'Christopher Covert'
    },
    content: {
      rendered: '',
      protected: false
    },
    featured_media: 0,
    template: '',
    acf: {
      name: 'Christopher Covert',
      position: 'Managing Director | Licensed Associate Real Estate Broker',
      phone: '',
      cell: '9178340635',
      email: 'covert@modlingroup.com',
      bio: '<div class="page" title="Page 1">\n<div class="layoutArea">\n<div class="column">\n<p>In an ever-changing marketplace, the ability to correctly interpret data and convey trends with confidence to buyers and sellers alike is the cornerstone for successful relationships that lead to smooth transactions. Christopher has gained the trust of his clients through consistently precise data analysis, and he has developed a strong skill in identifying the right investment opportunities, from raw land for new construction to existing homes ripe for improvement. His comprehensive knowledge of town and village codes and regulations, coupled with his ongoing study of market movement at both micro and macro levels enables him to provide the most detailed evaluation.</p>\n<p>Covert also brings to his real estate endeavors a solid foundation in architecture, design and construction. A social media leader known for unique branding and marketing initiatives along with an aptitude for always changing technologies, he is able to make a distinctive impression on the Hamptons marketplace. His real estate career follows 20+ years in film, television and music, where his work as a creative executive shaped both his business acumen and his keen eye.</p>\n</div>\n</div>\n</div>\n',
      headshot: '/team/Chris-Covert-MG-web-500x622-1.jpg',
      executive: false,
      location: 'HAMPTONS'
    },
    _links: {
      self: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/modlin_group_team/146'
        }
      ],
      collection: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/modlin_group_team'
        }
      ],
      about: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/types/modlin_group_team'
        }
      ],
      'wp:attachment': [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/media?parent=146'
        }
      ],
      curies: [
        {
          name: 'wp',
          href: 'https://api.w.org/{rel}',
          templated: true
        }
      ]
    }
  },
  {
    id: 128,
    date: '2023-02-09T19:12:41',
    date_gmt: '2023-02-09T19:12:41',
    guid: {
      rendered: 'https://cms.modlingroup.dbox.com/?post_type=modlin_group_team&#038;p=128'
    },
    modified: '2023-02-09T19:20:37',
    modified_gmt: '2023-02-09T19:20:37',
    slug: 'peter-davis',
    status: 'publish',
    type: 'modlin_group_team',
    link: 'https://cms.modlingroup.dbox.com/modlin_group_team/peter-davis/',
    title: {
      rendered: 'Peter Davis'
    },
    content: {
      rendered: '',
      protected: false
    },
    featured_media: 0,
    template: '',
    acf: {
      name: 'Peter Davis',
      position: 'Licensed Real Estate Salesperson',
      phone: '',
      cell: '3473740062',
      email: 'peter@modlingroup.com',
      bio: '<div class="page" title="Page 1">\n<div class="layoutArea">\n<div class="column">\n<p>Peter Davis is a licensed real estate salesperson and REBNY member who has lived on the Upper East Side for over 27 years. Originally from Boston, he moved to NYC in 1995 to pursue his passion in the high end luxury market. A strong determination to succeed and keen business acumen led to a richly rewarding and highly successful 30-year career in luxury sales. Peter cherishes his long and deep relationships with some of the most important people in their industries. He joins the prestigious Modlin Group, bringing a commitment to offer the highest level of service, integrity and privacy the Modlin Group is internationally extolled for.</p>\n<p>Peter has a thoughtful and dedicated approach to his business, using a warm and genuine passion for building relationships first, recognizing that trust and integrity are vital towards building a solid foundation for the future. He has a strong set of core values that shapes his everyday life and contributes to his continued successes. Client needs are met with the utmost care and dedication, while offering solutions with an outside the box thought process and creative finesse.</p>\n<p>Peter has a passion for photography, art, fine dining and music. He enjoys hiking in the desert and mountains, and recently trained for and completed his first NYC Marathon 2022. He plans to complete the six world majors in the future.</p>\n</div>\n</div>\n</div>\n',
      headshot: '/team/PeterDavis.jpg',
      executive: false
    },
    _links: {
      self: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/modlin_group_team/128'
        }
      ],
      collection: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/modlin_group_team'
        }
      ],
      about: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/types/modlin_group_team'
        }
      ],
      'wp:attachment': [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/media?parent=128'
        }
      ],
      curies: [
        {
          name: 'wp',
          href: 'https://api.w.org/{rel}',
          templated: true
        }
      ]
    }
  },
  {
    id: 45,
    date: '2020-06-05T18:06:48',
    date_gmt: '2020-06-05T18:06:48',
    guid: {
      rendered: 'http://3.228.218.122/?post_type=modlin_group_team&#038;p=45'
    },
    modified: '2020-06-15T19:10:23',
    modified_gmt: '2020-06-15T19:10:23',
    slug: 'jason-katz',
    status: 'publish',
    type: 'modlin_group_team',
    link: 'https://cms.modlingroup.dbox.com/modlin_group_team/jason-katz/',
    title: {
      rendered: 'Jason Katz'
    },
    content: {
      rendered: '',
      protected: false
    },
    featured_media: 0,
    template: '',
    acf: {
      name: 'Jason Katz',
      position: 'Licensed Real Estate Salesperson',
      phone: '2129740740',
      phone_extension: '12',
      cell: '6466604317',
      email: 'jason@modlingroup.com',
      bio: '<p>Jason Katz has been with Modlin Group since September 2014. Prior to joining Modlin Group, Jason worked at NBC News and NBC Sports for three years where he developed creative &amp; technical skills in TV production and digital at the highly accomplished TODAY show and the Olympics.</p>\n<p>Jason takes care of clients as if they are his family. He streamlines the process of buying, selling, and renting and breaks down the steps so that it&#8217;s an enjoyable experience. Attention to detail, client service, transparency, and confidentiality are hallmarks of Jason\u2019s ethic. Jason also has a knack for technology and connecting with people.</p>\n<p>Jason moved to the Upper East Side from Memphis, TN. He graduated from The University of Maryland in 2014 where he majored in broadcast journalism. Jason\u2019s interests include music, news, working out, and volunteering with New York Cares.</p>\n',
      headshot: '/team/Modlin_Group_Jason_500.jpg',
      executive: false
    },
    _links: {
      self: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/modlin_group_team/45'
        }
      ],
      collection: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/modlin_group_team'
        }
      ],
      about: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/types/modlin_group_team'
        }
      ],
      'wp:attachment': [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/media?parent=45'
        }
      ],
      curies: [
        {
          name: 'wp',
          href: 'https://api.w.org/{rel}',
          templated: true
        }
      ]
    }
  },
  {
    id: 145,
    date: '2023-02-09T20:11:45',
    date_gmt: '2023-02-09T20:11:45',
    guid: {
      rendered: 'https://cms.modlingroup.dbox.com/?post_type=modlin_group_team&#038;p=145'
    },
    modified: '2023-02-09T20:11:45',
    modified_gmt: '2023-02-09T20:11:45',
    slug: 'amy-landy',
    status: 'publish',
    type: 'modlin_group_team',
    link: 'https://cms.modlingroup.dbox.com/modlin_group_team/amy-landy/',
    title: {
      rendered: 'Amy Landy'
    },
    content: {
      rendered: '',
      protected: false
    },
    featured_media: 0,
    template: '',
    acf: {
      name: 'Amy Landy',
      position: 'Licensed Real Estate Salesperson',
      phone: '',
      cell: '9175977886',
      email: 'amy@modlingroup.com',
      bio: '<div class="page" title="Page 2">\n<div class="layoutArea">\n<div class="column">\n<p>Amy Landy is a true New Yorker. Born and raised in NYC, she has a natural passion for real estate and a firm pulse on the market. With a background in multifamily residential real estate, Amy has managed numerous Co-op and Condo sales as well as luxury rentals.</p>\n<p>She is a good listener, always prioritizes the needs of her clients, and makes sure to provide the highest level of service. Amy is an avid runner who loves exploring the city. She currently resides on the Upper East Side with her husband and four children.</p>\n</div>\n</div>\n</div>\n',
      headshot: '/team/AmyLandy.jpg',
      executive: false
    },
    _links: {
      self: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/modlin_group_team/145'
        }
      ],
      collection: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/modlin_group_team'
        }
      ],
      about: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/types/modlin_group_team'
        }
      ],
      'wp:attachment': [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/media?parent=145'
        }
      ],
      curies: [
        {
          name: 'wp',
          href: 'https://api.w.org/{rel}',
          templated: true
        }
      ]
    }
  },
  {
    id: 47,
    date: '2020-06-05T18:18:27',
    date_gmt: '2020-06-05T18:18:27',
    guid: {
      rendered: 'http://3.228.218.122/?post_type=modlin_group_team&#038;p=47'
    },
    modified: '2020-06-15T19:07:40',
    modified_gmt: '2020-06-15T19:07:40',
    slug: 'andrew-nierenberg',
    status: 'publish',
    type: 'modlin_group_team',
    link: 'https://cms.modlingroup.dbox.com/modlin_group_team/andrew-nierenberg/',
    title: {
      rendered: 'Andrew Nierenberg'
    },
    content: {
      rendered: '',
      protected: false
    },
    featured_media: 0,
    template: '',
    acf: {
      name: 'Andrew Nierenberg',
      position: 'Licensed Real Estate Salesperson',
      phone: '2129740740',
      phone_extension: '11',
      cell: '9178363195',
      email: 'andrew@modlingroup.com',
      bio: '<p>Andrew Nierenberg has had an accomplished career in luxury sales, fashion, and hospitality for the last 12 years. Andrew developed his detailed, driven and thorough hospitality approach first with five-star, five-diamond Four Seasons Hotel 57 th Street, as Maitre D\u2019 at the late French Chef, highest ranked Chef in the world, Joel Robuchon\u2019s first New York City restaurant. Following years spent in restaurants, Andrew\u2019s student-like perspective, he then spent 8 years with Ralph Lauren \u2013 first in sales and most recently managing client experience and hospitality.</p>\n<p>Andrew&#8217;s avid approach for developing relationships, displaying integrity and privacy, has led to his incomparable performance of service &#8212; that as a result, conditioned him to best service his Real Estate Clients. As a member of the boutique firm, Modlin Group, Andrew is committed to providing a world-class experience every Real Estate client deserves.</p>\n<p>Residing in New York with his wife and two children, Andrew is intimately familiar with the famed, New York City. Outside of real estate, he runs a foundation he and his brother created in memory of his late younger brother, Matthew &#8212; The Matthew Nierenberg Heart of Gold Foundation.</p>\n',
      headshot: '/team/Modlin_Group_Andrew_500.jpg',
      executive: false
    },
    _links: {
      self: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/modlin_group_team/47'
        }
      ],
      collection: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/modlin_group_team'
        }
      ],
      about: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/types/modlin_group_team'
        }
      ],
      'wp:attachment': [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/media?parent=47'
        }
      ],
      curies: [
        {
          name: 'wp',
          href: 'https://api.w.org/{rel}',
          templated: true
        }
      ]
    }
  },
  {
    id: 147,
    date: '2023-02-10T18:00:09',
    date_gmt: '2023-02-10T18:00:09',
    guid: {
      rendered: 'https://cms.modlingroup.dbox.com/?post_type=modlin_group_team&#038;p=147'
    },
    modified: '2025-05-12T12:10:59',
    modified_gmt: '2025-05-12T12:10:59',
    slug: 'kate-ozturk',
    status: 'publish',
    type: 'modlin_group_team',
    link: 'https://cms.modlingroup.dbox.com/modlin_group_team/kate-ozturk/',
    title: {
      rendered: 'Kate Lopez'
    },
    content: {
      rendered: '',
      protected: false
    },
    featured_media: 0,
    template: '',
    acf: {
      name: 'Kate Lopez',
      position: 'Director of Operations | Licensed as Ekaterina Lopez',
      phone: '',
      cell: '6317452946',
      email: 'kate@modlingroup.com',
      bio: '<div class="page" title="Page 1">\n<div class="layoutArea">\n<div class="column">\n<p>Born and raised in Chelyabinsk, Russia, Kate had always dreamed of living abroad. Upon finishing her studies and having acquired a Master\u2019s Degree in Linguistics and Intercultural Communication in 2010, she moved to Montauk. After initially establishing herself in the luxury hospitality industry, she soon transitioned to the luxury real estate business where she took expertise in management and customer service to the next level. Kate refers to herself as a people person, as anyone that has had the opportunity to work with her will confirm. Her knowledge of foreign languages and different cultures is a huge asset in the diverse community of the Hamptons. She is fluent in English and Russian and just getting going with Spanish.</p>\n</div>\n</div>\n</div>\n',
      headshot: '/team/Kate_Lopez.jpg',
      executive: false,
      location: 'HAMPTONS'
    },
    _links: {
      self: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/modlin_group_team/147'
        }
      ],
      collection: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/modlin_group_team'
        }
      ],
      about: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/types/modlin_group_team'
        }
      ],
      'wp:attachment': [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/media?parent=147'
        }
      ],
      curies: [
        {
          name: 'wp',
          href: 'https://api.w.org/{rel}',
          templated: true
        }
      ]
    }
  },
  {
    id: 148,
    date: '2023-02-10T18:00:15',
    date_gmt: '2023-02-10T18:00:15',
    guid: {
      rendered: 'https://cms.modlingroup.dbox.com/?post_type=modlin_group_team&#038;p=148'
    },
    modified: '2023-10-03T16:56:13',
    modified_gmt: '2023-10-03T16:56:13',
    slug: 'alex-pashkkowsky',
    status: 'publish',
    type: 'modlin_group_team',
    link: 'https://cms.modlingroup.dbox.com/modlin_group_team/alex-pashkkowsky/',
    title: {
      rendered: 'Alex Pashkowsky'
    },
    content: {
      rendered: '',
      protected: false
    },
    featured_media: 0,
    template: '',
    acf: {
      name: 'Alex Pashkowsky',
      position: 'Licensed Real Estate Salesperson',
      phone: '',
      cell: '9179125746',
      email: 'alex@modlingroup.com',
      bio: '<div class="page" title="Page 2">\n<div class="layoutArea">\n<div class="column">\n<p>Alex joins Modlin Group Hamptons after nearly three years at an ultra-luxury boutique real estate firm in Water Mill that specializes in $10M and above properties. He came to real estate following a 25-year career in management consulting, where he helped guide executive leaders in strategy development, M&amp;A activities and business portfolio initiatives for such firms as Citibank, Merrill, Deutsche Bank, Visa, Pfizer, Facebook, Salesforce, Estee Lauder and leading private equity firms.</p>\n<p>Alex attributes his successful consulting career to paying detailed attention to his clients\u2019 needs, simplifying complex situations and creating tangible results that build long term value for clients. He employs these same principles in real estate by listening closely to the homebuyer\u2019s preferences and then presenting a curated selection of properties that fit the buyer\u2019s requirements. For sellers, he creates customized marketing strategies to identify and attract the right buyers.</p>\n<p>Prior to consulting, Alex provided investment banking services to buy, sell and finance real estate projects for developers, property owners and institutional investors. He earned an MBA in Finance from NYU\u2019s Stern School of Business and a BA in Finance from GWU.</p>\n<p>Alex has resided in Manhattan for 25 years and the Hamptons since 2010. Along with his partner, an acclaimed interior designer of ultra-luxury homes for high-end clients, he has owned homes in Water Mill, North Haven, and Sag Harbor, where he served as a member of the Architectural Review Board. He is passionate about architecture, design and maximizing the appreciation potential of real estate.</p>\n</div>\n</div>\n</div>\n',
      headshot: '/team/Alex-Pashkowsky-MG-web.jpg',
      executive: false,
      location: 'HAMPTONS'
    },
    _links: {
      self: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/modlin_group_team/148'
        }
      ],
      collection: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/modlin_group_team'
        }
      ],
      about: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/types/modlin_group_team'
        }
      ],
      'wp:attachment': [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/media?parent=148'
        }
      ],
      curies: [
        {
          name: 'wp',
          href: 'https://api.w.org/{rel}',
          templated: true
        }
      ]
    }
  },
  {
    id: 39,
    date: '2020-06-05T17:57:27',
    date_gmt: '2020-06-05T17:57:27',
    guid: {
      rendered: 'http://3.228.218.122/?post_type=modlin_group_team&#038;p=39'
    },
    modified: '2020-06-10T21:32:41',
    modified_gmt: '2020-06-10T21:32:41',
    slug: 'traci-l-sands',
    status: 'publish',
    type: 'modlin_group_team',
    link: 'https://cms.modlingroup.dbox.com/modlin_group_team/traci-l-sands/',
    title: {
      rendered: 'Traci L. Sands'
    },
    content: {
      rendered: '',
      protected: false
    },
    featured_media: 0,
    template: '',
    acf: {
      name: 'Traci L. Sands',
      position: 'Director of Administration & Operations',
      phone: '2129740740',
      phone_extension: '13',
      cell: '',
      email: 'traci@modlingroup.com',
      bio: '<p>Traci L. Sands is a highly skilled administrator with 23 years experience in executive and staff administration as well as a strong background in marketing and sales management. She has valuable experience in office information technology, logistics, and training. Before joining The Modlin Group, Traci worked at notable top investment advisory and real estate firms specializing in multi-level client services. Traci has a proven herself to be extremely proficient in developing successful office policies and procedures which result in seamless and efficient\u00a0 operations with end goal being profitable ventures and acquisitions.</p>\n',
      headshot: '/team/Modlin_Group_Traci_500.jpg',
      executive: false
    },
    _links: {
      self: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/modlin_group_team/39'
        }
      ],
      collection: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/modlin_group_team'
        }
      ],
      about: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/types/modlin_group_team'
        }
      ],
      'wp:attachment': [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/media?parent=39'
        }
      ],
      curies: [
        {
          name: 'wp',
          href: 'https://api.w.org/{rel}',
          templated: true
        }
      ]
    }
  },
  {
    id: 49,
    date: '2020-06-05T18:19:36',
    date_gmt: '2020-06-05T18:19:36',
    guid: {
      rendered: 'http://3.228.218.122/?post_type=modlin_group_team&#038;p=49'
    },
    modified: '2022-02-03T19:42:50',
    modified_gmt: '2022-02-03T19:42:50',
    slug: 'marisa-sargent',
    status: 'publish',
    type: 'modlin_group_team',
    link: 'https://cms.modlingroup.dbox.com/modlin_group_team/marisa-sargent/',
    title: {
      rendered: 'Marisa Sargent'
    },
    content: {
      rendered: '',
      protected: false
    },
    featured_media: 0,
    template: '',
    acf: {
      name: 'Marisa Sargent',
      position: 'Licensed Real Estate Salesperson',
      phone: '2129740740',
      phone_extension: '16',
      cell: '5167702359',
      email: 'marisa@modlingroup.com',
      bio: '<p>Marisa Sargent joined Modlin Group in 2007. Prior to joining Modlin Group, Marisa worked at Sotheby\u2019s International Realty for three years, where she handled over $90 million in high-profile sales with a Senior Vice President. The success she\u2019s achieved in her 18-year career is attributed to providing an outstanding level of service, attention to detail and a conscientious awareness of the needs of each client. Discretion and confidentiality are two key elements of Marisa&#8217;s business practices.</p>\n<p>Marisa, a native New Yorker, graduated with top honors from New York University&#8217;s Tisch School of the Arts. The urban setting of that campus gave her an early appreciation and knowledge of Manhattan real estate. That appreciation manifests itself in her sharp eye towards pricing and value of the properties she represents. Marisa&#8217;s interests include theater and sports. She is a former All- Long Island top ten ranked basketball player and Varsity captain. She brings to the real estate field, the same competitiveness and drive that were honed in that athletic arena. Marisa, a member of REBNY, builds true relationships with her clients. These relationships are built with her own knack of personalizing each transaction.</p>\n',
      headshot: '/team/Modlin_Group_Marisa_500.jpg',
      executive: false
    },
    _links: {
      self: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/modlin_group_team/49'
        }
      ],
      collection: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/modlin_group_team'
        }
      ],
      about: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/types/modlin_group_team'
        }
      ],
      'wp:attachment': [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/media?parent=49'
        }
      ],
      curies: [
        {
          name: 'wp',
          href: 'https://api.w.org/{rel}',
          templated: true
        }
      ]
    }
  },
  {
    id: 51,
    date: '2020-06-05T18:21:11',
    date_gmt: '2020-06-05T18:21:11',
    guid: {
      rendered: 'http://3.228.218.122/?post_type=modlin_group_team&#038;p=51'
    },
    modified: '2023-02-21T15:22:36',
    modified_gmt: '2023-02-21T15:22:36',
    slug: 'frederique-svider',
    status: 'publish',
    type: 'modlin_group_team',
    link: 'https://cms.modlingroup.dbox.com/modlin_group_team/frederique-svider/',
    title: {
      rendered: 'Frederique Svider'
    },
    content: {
      rendered: '',
      protected: false
    },
    featured_media: 0,
    template: '',
    acf: {
      name: 'Frederique Svider',
      position: 'Licensed Real Estate Salesperson',
      phone: '2129740740',
      phone_extension: '18',
      cell: '',
      email: 'fred@modlingroup.com',
      bio: '<p>N/A</p>\n',
      headshot: '/team/Modlin_Group_Frederique_500.jpg',
      executive: false,
      location: 'MANHATTAN'
    },
    _links: {
      self: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/modlin_group_team/51'
        }
      ],
      collection: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/modlin_group_team'
        }
      ],
      about: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/types/modlin_group_team'
        }
      ],
      'wp:attachment': [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/media?parent=51'
        }
      ],
      curies: [
        {
          name: 'wp',
          href: 'https://api.w.org/{rel}',
          templated: true
        }
      ]
    }
  },
  {
    id: 183,
    date: '2023-10-03T14:27:47',
    date_gmt: '2023-10-03T14:27:47',
    guid: {
      rendered: 'https://cms.modlingroup.dbox.com/?post_type=modlin_group_team&#038;p=183'
    },
    modified: '2024-12-11T14:14:29',
    modified_gmt: '2024-12-11T14:14:29',
    slug: 'flora-veitch',
    status: 'publish',
    type: 'modlin_group_team',
    link: 'https://cms.modlingroup.dbox.com/modlin_group_team/flora-veitch/',
    title: {
      rendered: 'Flora Veitch'
    },
    content: {
      rendered: '',
      protected: false
    },
    featured_media: 0,
    template: '',
    acf: {
      name: 'Flora Delavalle',
      position: 'Licensed Real Estate Salesperson | Licensed as Flora Veitch',
      phone: '8459013340',
      phone_extension: '',
      cell: '',
      email: 'flora@modlingroup.com',
      bio: '<p>Flora\u2019s approach to real estate demonstrates a unique blend of creativity and strategy. Her primary commitment lies in educating her clients about the intricacies of the Hamptons market, thereby facilitating well-informed decision-making grounded in data. Flora is well-versed in both construction and renovation projects, as well as the landscape of village and town building codes and regulations. She attentively listens to her clients\u2019 desires and requirements, approaching each deal with consideration and a measured demeanor in her actions and responses. Her assertive nature proves invaluable during negotiations, while her poised and comforting presence serves as a pillar of support for her clients.</p>\n<p>Flora embarked on her real estate journey with the aspiration of attaining independence from corporate structures and establishing her own business. Following a distinguished tenure in the financial sector during which she managed marketing for a global banking institution, she seamlessly transitioned to the realm of real estate. Her unwavering work ethic, combined with an unrelenting drive for success, has consistently enabled her to deliver tangible outcomes for her clients.</p>\n',
      headshot: '/team/Flora-Veitch.jpg',
      executive: false,
      location: 'HAMPTONS'
    },
    _links: {
      self: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/modlin_group_team/183'
        }
      ],
      collection: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/modlin_group_team'
        }
      ],
      about: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/types/modlin_group_team'
        }
      ],
      'wp:attachment': [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/media?parent=183'
        }
      ],
      curies: [
        {
          name: 'wp',
          href: 'https://api.w.org/{rel}',
          templated: true
        }
      ]
    }
  },
  {
    id: 220,
    date: '2025-09-29T12:35:58',
    date_gmt: '2025-09-29T12:35:58',
    guid: {
      rendered: 'https://cms.modlingroup.dbox.com/?post_type=modlin_group_team&#038;p=220'
    },
    modified: '2025-09-29T12:37:36',
    modified_gmt: '2025-09-29T12:37:36',
    slug: 'chelsea-baetz',
    status: 'publish',
    type: 'modlin_group_team',
    link: 'https://cms.modlingroup.dbox.com/modlin_group_team/chelsea-baetz/',
    title: {
      rendered: 'Chelsea Baetz'
    },
    content: {
      rendered: '',
      protected: false
    },
    featured_media: 0,
    template: '',
    acf: {
      name: 'Chelsea Baetz',
      position: 'Licensed Associate Real Estate Broker | Licensed as Chelsea Ann Baetz',
      phone: '2012065626',
      phone_extension: '',
      cell: '',
      email: 'chelsea@modlingroup.com',
      bio: '<p>Chelsea Baetz is a multi-million-dollar producer and trusted luxury real estate advisor specializing in the Hamptons market. A Southampton Village resident with deep local insight, Chelsea has built her reputation on results, integrity, and an unmatched ability to navigate even the most competitive transactions. She thrives in challenging scenarios, consistently securing the best outcomes for her clients while maintaining her hallmark calm and composed approach.</p>\n<p>Chelsea’s career began with co-founding a real estate brokerage at a young age, later managing one of the largest and most successful firms in the business for six years. That experience honed her leadership skills and broadened her perspective, laying the foundation for her success in high-end Hamptons sales and rentals today. Known for her ethical approach, meticulous attention to detail, and creative marketing strategies, she continues to set the bar in the luxury market.</p>\n<p>Outside of real estate, Chelsea has enjoyed giving back to her community, from volunteering to supporting local initiatives. She also values staying active, spending time with her daughter and husband, playing tennis, and pursuing entrepreneurial projects. Whether helping families find their Hamptons home or encouraging young girls to lead with kindness, Chelsea approaches everything with dedication, warmth, and care.</p>\n<p>She believes that luxury isn’t just about homes &#8211; it’s about the quality of life and meaningful moments created within them.</p>\n',
      headshot: '/team/Chelsea_Baetz.jpg',
      executive: false,
      location: 'HAMPTONS'
    },
    _links: {
      self: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/modlin_group_team/220'
        }
      ],
      collection: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/modlin_group_team'
        }
      ],
      about: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/types/modlin_group_team'
        }
      ],
      'wp:attachment': [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/media?parent=220'
        }
      ],
      curies: [
        {
          name: 'wp',
          href: 'https://api.w.org/{rel}',
          templated: true
        }
      ]
    }
  },
  {
    id: 149,
    date: '2023-02-10T18:00:04',
    date_gmt: '2023-02-10T18:00:04',
    guid: {
      rendered: 'https://cms.modlingroup.dbox.com/?post_type=modlin_group_team&#038;p=149'
    },
    modified: '2023-02-21T15:22:02',
    modified_gmt: '2023-02-21T15:22:02',
    slug: 'michael-norbeck',
    status: 'publish',
    type: 'modlin_group_team',
    link: 'https://cms.modlingroup.dbox.com/modlin_group_team/michael-norbeck/',
    title: {
      rendered: 'Michael Norbeck'
    },
    content: {
      rendered: '',
      protected: false
    },
    featured_media: 0,
    template: '',
    acf: {
      name: 'Michael Norbeck',
      position: 'Licensed Real Estate Salesperson',
      phone: '',
      cell: '3476102065',
      email: 'michael@modlingroup.com',
      bio: '<div class="page" title="Page 2">\n<div class="layoutArea">\n<div class="column">\n<p>Mike joins Modlin Group Hamptons after nearly seven years at a local luxury Bridgehampton boutique real estate firm, prior to which he was involved in residential real estate in Manhattan for several years. Having grown up in East Quogue, Mike brings his experience back home to the East End, possessing a native&#8217;s knowledge of the villages, hamlets, and neighborhoods of the Hamptons.</p>\n<p>Applying that knowledge to his real estate endeavors, Mike not only welcomes clients to experience the best the Hamptons has to offer, but guides them to make astute investments as well.</p>\n<p>A true entrepreneur, Mike also owns one of the most successful businesses based at East Hampton Airport. It was his early interest in aviation that led to a career in that field, and he earned his pilot&#8217;s license while still in high school, following with a bachelor&#8217;s degree in Aeronautics. For 18 years, Mike worked at the East Hampton Airport for one of the fixed base operators, and continues to fly there recreationally.</p>\n</div>\n</div>\n</div>\n',
      headshot: '/team/Michael_Norbeck.jpg',
      executive: false,
      location: 'HAMPTONS'
    },
    _links: {
      self: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/modlin_group_team/149'
        }
      ],
      collection: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/modlin_group_team'
        }
      ],
      about: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/types/modlin_group_team'
        }
      ],
      'wp:attachment': [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/media?parent=149'
        }
      ],
      curies: [
        {
          name: 'wp',
          href: 'https://api.w.org/{rel}',
          templated: true
        }
      ]
    }
  },
  {
    id: 209,
    date: '2025-07-11T18:11:02',
    date_gmt: '2025-07-11T18:11:02',
    guid: {
      rendered: 'https://cms.modlingroup.dbox.com/?post_type=modlin_group_team&#038;p=209'
    },
    modified: '2025-07-11T18:50:03',
    modified_gmt: '2025-07-11T18:50:03',
    slug: 'cleo-ahn',
    status: 'publish',
    type: 'modlin_group_team',
    link: 'https://cms.modlingroup.dbox.com/modlin_group_team/cleo-ahn/',
    title: {
      rendered: 'Cleo Ahn'
    },
    content: {
      rendered: '',
      protected: false
    },
    featured_media: 0,
    template: '',
    acf: {
      name: 'Cleo Ahn',
      position: 'Licensed Real Estate Salesperson',
      phone: '9174450927',
      phone_extension: '',
      cell: '',
      email: 'cleo@modlingroup.com',
      bio: '<p>Cleo Ahn brings a refined eye, a sharp business acumen, and a deep-rooted creative sensibility to her work in real estate. She began her career at Douglas Elliman and now joins the Modlin Group, where she combines her expertise in digital marketing and design with a strong network of industry professionals including architects, interior designers, builders, and art advisors to deliver bespoke solutions tailored to each client\u2019s vision.</p>\n<p>Before transitioning into real estate, Cleo led creative teams in the fashion industry, overseeing e-commerce development, private-label design, production, photography, and content strategy. Her work in apparel and fine jewelry has been featured in publications such as Vogue, Elle, Fashion Canada, and Nylon, and carried by luxury retailers including Moda Operandi, Shopbop, Revolve, and Barneys New York.</p>\n<p>A global citizen, Cleo was raised in Vancouver, Canada and studied at Parsons School of Design in New York. She spent several years working between New York and Hong Kong, gaining international perspective and cultivating a sophisticated aesthetic that now informs her real estate approach.</p>\n<p>Cleo and her husband have summered in Southampton for over a decade and made the Hamptons their full-time home in 2020, where they live with their three children. Deeply involved in the East End community, Cleo serves on the Board of Trustees at the Watermill Center, a renowned interdisciplinary arts foundation, and sits on the Advisory Board of the Bridgehampton Child Care &amp; Recreation Center, which supports under-resourced local families.</p>\n<p>An avid reader and tennis player, Cleo is passionate about real estate, design, photography, and the arts &#8211; passions she seamlessly integrates into her work, offering clients not just transactions, but elevated experiences and meaningful connections to place.</p>\n',
      headshot: '/team/Cleo_Ahn.jpg',
      executive: false,
      location: 'HAMPTONS'
    },
    _links: {
      self: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/modlin_group_team/209'
        }
      ],
      collection: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/modlin_group_team'
        }
      ],
      about: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/types/modlin_group_team'
        }
      ],
      'wp:attachment': [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/media?parent=209'
        }
      ],
      curies: [
        {
          name: 'wp',
          href: 'https://api.w.org/{rel}',
          templated: true
        }
      ]
    }
  },
  {
    id: 225,
    date: '2025-10-13T15:25:58',
    date_gmt: '2025-10-13T15:25:58',
    guid: {
      rendered: 'https://cms.modlingroup.dbox.com/?post_type=modlin_group_team&#038;p=225'
    },
    modified: '2025-10-13T15:25:58',
    modified_gmt: '2025-10-13T15:25:58',
    slug: 'natalia-benjamin',
    status: 'publish',
    type: 'modlin_group_team',
    link: 'https://cms.modlingroup.dbox.com/modlin_group_team/natalia-benjamin/',
    title: {
      rendered: 'Natalia Benjamin'
    },
    content: {
      rendered: '',
      protected: false
    },
    featured_media: 0,
    template: '',
    acf: {
      name: 'Natalia Benjamin',
      position: 'Licensed Real Estate Salesperson',
      phone: '6462488212',
      phone_extension: '',
      cell: '',
      email: 'natalia@modlingroup.com',
      bio: '<p>Natalia has more than a decade of hands-on experience purchasing, developing, selling, and renting property throughout the Hamptons. She blends financial expertise with a designer’s eye and a developer’s experience to offer a truly holistic approach to Hamptons real estate.</p>\n<p>With a background in finance, Natalia brings the analytical mindset needed to interpret market trends, compare properties, assess real estate value, and provide clients with clear, data-driven guidance. Natalia’s career began on Wall Street, where she held roles at Citigroup and BlackRock, refining her ability to navigate complex markets, bring attention to detail, and negotiate win-win solutions. She holds a Master’s degree in Financial Mathematics from the University of Chicago, a foundation that informs her data-driven approach to valuation and strategy.</p>\n<p>Natalia has invested in real estate and designed and developed high-end homes across the Hamptons. That experience brings first-hand knowledge of local codes and regulations, building costs, and every facet of property design and development—expertise clients rely on whether seeking a turn-key estate, raw land, or a home primed for transformation.</p>\n<p>Natalia’s professional experience is matched by her personal warmth and global outlook. Well-traveled to over 45 countries, she brings an international luxury perspective to the Hampton’s market. She lives in the Hamptons with her husband and three daughters, where she continues to cultivate long-standing relationships and help clients achieve their vision of Hamptons living.</p>\n',
      headshot: '/team/Natalia_Benjamin.jpg',
      executive: false,
      location: 'HAMPTONS'
    },
    _links: {
      self: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/modlin_group_team/225'
        }
      ],
      collection: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/modlin_group_team'
        }
      ],
      about: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/types/modlin_group_team'
        }
      ],
      'wp:attachment': [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/media?parent=225'
        }
      ],
      curies: [
        {
          name: 'wp',
          href: 'https://api.w.org/{rel}',
          templated: true
        }
      ]
    }
  }
]
